import { Injectable } from '@angular/core';
import { Alert } from '../models/alert';
import {HttpService} from "./http.service";
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class AlertService {
    constructor(
        private httpService: HttpService
    ) {}
    getBaseAlerts(): Promise<Alert[]> {
        //TODO - this will call /Alerts to get names / ids
        //return Promise.resolve(ALERTS);
        let me = this;
        return this.httpService.get(`/Alerts`, {})
            .then(function(results: any){
                return new Alert().fromJsonArray(results);
            })
            .catch(function(error: any){
                me.httpService.handleError(error, "Unable to connect to the server")
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/services/alerts.service.ts